import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavbarDemo from "./NavbarDemo";
import Footer from "./pages/Footer/Footer";
import ServicesSection from "./ServicesSection";
import LeadershipSection from "./LeadershipSection";
import RoadmapToResults from "./RoadmapToResults";
import VisionForFuture from "./VisionForFuture";
import SuccessStoriesPage from "./SuccessStoriesPage";
import CommonQuestionsPage from "./CommonQuestionsPage";
import OurExpertise from "./pages/About/OurExpertise";
import RightTimeSuccess from "./pages/About/RightTimeSuccess";
import EmailChatSupport from "./pages/Business/BPO/EmailChatSupport";
import SmsSupport from "./pages/Business/BPO/SmsSupport";
import MedicalBilling from "./pages/Business/Healthcare/MedicalBilling";
import MedicalTranscription from "./pages/Business/Healthcare/MedicalTranscriptions";
import MedicalExcellence from "./pages/Business/Healthcare/MedicalExcellence";
import BPO from "./pages/Business/BPO/BPO";
import Home from "./pages/Home/Home";
import InboundCalls from "./pages/Business/BPO/InBoundCalls";
import OutboundCalls from "./pages/Business/BPO/OutBoundCalls";
import './App.css'
import HealthCare from "./pages/Business/Healthcare/HealthCare";
import WebDevelopment from "./pages/Business/DigitalMarketing/WebDevelopment";
import Content from "./pages/Business/DigitalMarketing/Content";
import Seo from "./pages/Business/DigitalMarketing/Seo";
import SocialMedia from "./pages/Business/DigitalMarketing/SocialMedia";
import GraphicDesigning from "./pages/Business/DigitalMarketing/GraphicDesigning";
import UiUxDesigning from "./pages/Business/DigitalMarketing/UiUxDesigning";
import ItServices from "./pages/Services/ItServices";
import BookMeeting from "./BookMeeting";

function App() {
  return (
    <Router>
      <NavbarDemo />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bookmeeting" element={<BookMeeting />} />
        <Route path="/services" element={<ServicesSection />} />
        <Route path="/leadership" element={<LeadershipSection />} />
        <Route path="/roadmap" element={<RoadmapToResults />} />
        <Route path="/vision" element={<VisionForFuture />} />
        <Route path="/success-stories" element={<SuccessStoriesPage />} />
        <Route path="/questions" element={<CommonQuestionsPage />} />

        {/* About Section */}
        <Route path="/our-expertise" element={<OurExpertise />} />
        <Route path="/right-time-success" element={<RightTimeSuccess />} />

        {/* BPO Services */}
        <Route path="/bpo" element={<BPO />} />
        <Route path="/inbound" element={<InboundCalls />} />
        <Route path="/outbound" element={<OutboundCalls />} />
        <Route path="/email-support" element={<EmailChatSupport />} />
        <Route path="/sms-support" element={<SmsSupport />} />

        {/* Healthcare Services */}
        <Route path="/healthcare" element={<HealthCare />} />
        <Route path="/medical-billing" element={<MedicalBilling />} />
        <Route path="/medical-transcription" element={<MedicalTranscription />} />
        <Route path="/excellence" element={<MedicalExcellence />} />

        {/* Digital Markting */}
        <Route path="/web" element={<WebDevelopment />} />
        <Route path="/content" element={<Content />} />
        <Route path="/seo" element={<Seo />} />
        <Route path="/social" element={<SocialMedia />} />
        <Route path="/graphics" element={<GraphicDesigning />} />
        <Route path="/uiux" element={<UiUxDesigning />} />

        {/* IT Services */}
        <Route path="/itservice" element={<ItServices />} />

        {/* Submenu Routes */}
        {/* <Route path="/inbound" element={<Inbound />} /> */}
        {/* <Route path="/outbound" element={<OutBound />} /> */}
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
